import { render, staticRenderFns } from "./ConfiguracaoMeioPagamentoList.vue?vue&type=template&id=ec224eda"
import script from "./ConfiguracaoMeioPagamentoList.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoMeioPagamentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports